module.exports = __webpack_public_path__ + "static/media/banner_ecommerce_Mesa_de_trabajo_1.ed846f89.jpg";